import { EditPageRecommendationsData } from '../../typings/recommendations';

export const UPDATE_RECOMMENDATIONS_FOR_GROUPS_EDIT = 'UPDATE_RECOMMENDATIONS_FOR_GROUPS_EDIT';
export type UPDATE_RECOMMENDATIONS_FOR_GROUPS_EDIT = typeof UPDATE_RECOMMENDATIONS_FOR_GROUPS_EDIT;

export interface UpdateRecommendationsForGroupsEditAction {
    type: UPDATE_RECOMMENDATIONS_FOR_GROUPS_EDIT;
    recommendations: Record<string, EditPageRecommendationsData>;
}

export function updateRecommendationsForGroupsEdit(
    recommendations: Record<string, EditPageRecommendationsData>
): UpdateRecommendationsForGroupsEditAction {
    return {
        type: UPDATE_RECOMMENDATIONS_FOR_GROUPS_EDIT,
        recommendations
    };
}

export const FETCH_RECOMMENDATIONS_FOR_GROUPS_EDIT = 'FETCH_RECOMMENDATIONS_FOR_GROUPS_EDIT';
export type FETCH_RECOMMENDATIONS_FOR_GROUPS_EDIT = typeof FETCH_RECOMMENDATIONS_FOR_GROUPS_EDIT;

export interface FetchRecommendationsForGroupsEditAction {
    type: FETCH_RECOMMENDATIONS_FOR_GROUPS_EDIT;
    login: string;
    groupIds: Array<string>;
    campainIds: Array<string>;
}

export function fetchRecommendationsForGroupsEdit(
    login: string,
    campainIds: Array<string>,
    groupIds: Array<string>
): FetchRecommendationsForGroupsEditAction {
    return {
        type: FETCH_RECOMMENDATIONS_FOR_GROUPS_EDIT,
        login,
        groupIds,
        campainIds
    };
}

export const CLOSE_RECOMMENDATIONS_FOR_GROUPS_EDIT = 'CLOSE_RECOMMENDATIONS_FOR_GROUPS_EDIT';
export type CLOSE_RECOMMENDATIONS_FOR_GROUPS_EDIT = typeof CLOSE_RECOMMENDATIONS_FOR_GROUPS_EDIT;

export interface CloseRecommendationsForGroupsEditAction {
    type: CLOSE_RECOMMENDATIONS_FOR_GROUPS_EDIT;
    id: string;
}

export function onCloseRecommendationsForGroupsEdit(id: string): CloseRecommendationsForGroupsEditAction {
    return {
        type: CLOSE_RECOMMENDATIONS_FOR_GROUPS_EDIT,
        id
    };
}

export const OPEN_RECOMMENDATIONS_MODAL_FOR_GROUPS_EDIT = 'OPEN_RECOMMENDATIONS_MODAL_FOR_GROUPS_EDIT';
export type OPEN_RECOMMENDATIONS_MODAL_FOR_GROUPS_EDIT = typeof OPEN_RECOMMENDATIONS_MODAL_FOR_GROUPS_EDIT;

export interface OpenRecommendationsModalForGroupsEditAction {
    type: OPEN_RECOMMENDATIONS_MODAL_FOR_GROUPS_EDIT;
    id: string;
}

export function openRecommendationsModalForGroupsEdit(id: string): OpenRecommendationsModalForGroupsEditAction {
    return {
        type: OPEN_RECOMMENDATIONS_MODAL_FOR_GROUPS_EDIT,
        id
    };
}

export type GroupsEditRecommendationsAction =
    | OpenRecommendationsModalForGroupsEditAction
    | UpdateRecommendationsForGroupsEditAction
    | CloseRecommendationsForGroupsEditAction
    | FetchRecommendationsForGroupsEditAction;
